export const GetDocumentFolderStructureForArtNo = (api, index) => {
    return api.get(`/api/v1/DataFolder/GetDocumentFolderStructure?artNo=${index}`)
}

